import { B as BigValueTextMode, P as PercentChangeColorMode, a as BigValueJustifyMode, b as BigValueGraphMode, c as BigValueColorMode } from '../../../../../index-DuYVZf5J.js';

"use strict";
const pluginVersion = "13.0.0-pre";
const defaultOptions = {
  colorMode: BigValueColorMode.Value,
  graphMode: BigValueGraphMode.Area,
  justifyMode: BigValueJustifyMode.Auto,
  percentChangeColorMode: PercentChangeColorMode.Standard,
  showPercentChange: false,
  textMode: BigValueTextMode.Auto,
  wideLayout: true
};

export { defaultOptions, pluginVersion };
